import { RATIO, TypographySize } from 'mm-theme-configuration/dist/consts';

export const componentConfigThemeKey = 'relatedPosts';

export interface RelatedPostsThemeProps {
  titleFontSizeLarge: TypographySize;
  titleFontSizeMedium: TypographySize;
  titleFontSizeSmall: TypographySize;
  titleColor: string;
  backgroundColor: string;
  largeHorizontalGap: number;
  mediumHorizontalGap: number;
  smallHorizontalGap: number;
  articleTitleFontSizeLarge: TypographySize;
  articleTitleFontSizeMedium: TypographySize;
  articleTitleFontSizeSmall: TypographySize;
  metadataFontSizeLarge: TypographySize;
  metadataFontSizeMedium: TypographySize;
  metadataFontSizeSmall: TypographySize;
  descriptionFontSizeLarge: TypographySize;
  descriptionFontSizeMedium: TypographySize;
  descriptionFontSizeSmall: TypographySize;
  mainCategoryFontSizeLarge: TypographySize;
  mainCategoryFontSizeMedium: TypographySize;
  mainCategoryFontSizeSmall: TypographySize;
  cardProportionsLarge: RATIO;
  cardProportionsMedium: RATIO;
  cardProportionsSmall: RATIO;
  cardTitleColorTypeNormal: string;
  cardTitleColorTypeHover: string;
  cardTitleColorTypeActive: string;
  cardBoxShadowTypeNormal: string;
  cardBoxShadowTypeActive: string;
  cardBoxShadowTypeHover: string;
  cardBorderWidthTypeNormal: number;
  cardBorderWidthTypeHover: number;
  cardBorderWidthTypeActive: number;
  cardBorderColorTypeNormal: string;
  cardBorderColorTypeHover: string;
  cardBorderColorTypeActive: string;
  cardHorizontalGapLarge: number;
  cardHorizontalGapMedium: number;
  cardHorizontalGapSmall: number;
  pipeColor: string;
}
